import styled from "styled-components";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
  &.results {
    max-height: 450px;
    min-width: 350px;
    overflow-y: auto;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
      max-height: unset;
      min-height: unset;
    }
  }
`;
